export default __webpack_public_path__ + "media/verification/title_locale_fr-3cf8c6bc.png";